module.exports = __webpack_public_path__ + "static/media/vivaticket-mobile.7b1c9fe6.svg";